<script>
import './http'

export default {
  mounted () {
    if (window.parent && window.parent.setWindowDesignRelatorio) {
      window.parent.setWindowDesignRelatorio(this.$refs.designer)
    }
  },
  methods: {
    save (report) {
      if (window.parent && window.parent.windowDesignRelatorioSave) window.parent.windowDesignRelatorioSave(report)
    },
    exit () {
      if (window.parent && window.parent.windowDesignRelatorioExit) window.parent.windowDesignRelatorioExit()
    }
  }
}
</script>
<template>
  <ui-st-designer ref="designer" @save="save" @exit="exit" />
</template>
